import { ApplicationRef, Component, inject, NgZone, OnDestroy, OnInit, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { first, interval, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-update',
  imports: [],
  templateUrl: './update.component.html',
  styleUrl: './update.component.scss',
})
export class UpdateComponent implements OnInit, OnDestroy {
  protected updateAvailable = signal<boolean>(false);
  private appRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate);
  private zone = inject(NgZone);
  private destroy$ = new Subject<void>();
  private readonly checkInterval = 1 * 60 * 60 * 1000; // 1 hour

  ngOnInit(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    const appIsStable$ = this.appRef.isStable.pipe(
      first((isStable) => isStable),
      takeUntil(this.destroy$),
    );
    const periodically$ = interval(this.checkInterval).pipe(takeUntil(this.destroy$));

    this.zone.runOutsideAngular(() => {
      // Automatically activate and reload when update is found
      appIsStable$.subscribe(async () => {
        this.updateAvailable.set(await this.swUpdate.checkForUpdate());
        if (this.updateAvailable()) {
          this.updateApp();
        }
      });

      // Check every hour for updates and notify user
      periodically$.subscribe(async () => {
        if (this.updateAvailable()) {
          return;
        }
        this.updateAvailable.set(await this.swUpdate.checkForUpdate());
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected updateApp(): void {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }
}
